import DataDisplayRowI from "../DataDisplayRowI";
import getVoucherBdayRow from "../DataDisplayRow/VoucherBdayRow";
import DataDisplayTable from "../DataDisplayTable";

class VoucherBdayTable extends DataDisplayTable {
    #row!: DataDisplayRowI

    generateRow(): DataDisplayRowI {
        this.#row = getVoucherBdayRow()
        return this.#row
    }
}

let voucherBdayTable: VoucherBdayTable | null = null;

export default function getVoucherBdayTable(): VoucherBdayTable {
    if (voucherBdayTable === null)
        voucherBdayTable = new VoucherBdayTable()
    return voucherBdayTable
}